import { useTheme } from 'styled-components'

import { Loading } from '@reveni-io/reveni-ui'

import ChartDisplayToggle from '@/metrics/components/ChartDisplayToggle/ChartDisplayToggle'
import CustomLegend from '@/metrics/components/CustomLegend/CustomLegend'
import OpenChartInModal from '@/metrics/components/OpenChartInModal/OpenChartInModal'
import { getRatioBarsChartLegendItems } from '@/metrics/components/RatioBarsChart/helpers'
import RatioBarsChart from '@/metrics/components/RatioBarsChart/RatioBarsChart'

import { getReturnsAndExchangesChartSeries } from './helpers'
import * as Styles from './styles'

const ReturnsAndExchangesBarsChart = ({
  data,
  timeRangeSelected,
  fullWidth,
  timeDisplay,
  onChangeTimeDisplay,
  showOpenInModal,
  modalTitle,
  loading,
}) => {
  const theme = useTheme()
  const series = getReturnsAndExchangesChartSeries(theme)

  return (
    <Styles.ChartContainer>
      <Styles.ChartHeader>
        <CustomLegend legendItems={getRatioBarsChartLegendItems(series)} />
        <Styles.ActionsContainer>
          <ChartDisplayToggle value={timeDisplay} onChange={onChangeTimeDisplay} />
          <OpenChartInModal
            show={showOpenInModal}
            modalTitle={modalTitle}
            chart={
              <ReturnsAndExchangesBarsChart
                data={data}
                loading={loading}
                timeRangeSelected={timeRangeSelected}
                fullWidth
                timeDisplay={timeDisplay}
                onChangeTimeDisplay={onChangeTimeDisplay}
              />
            }
          />
        </Styles.ActionsContainer>
      </Styles.ChartHeader>
      <Loading show={loading} height="210px">
        <RatioBarsChart data={data} series={series} timeRangeSelected={timeRangeSelected} fullWidth={fullWidth} />
      </Loading>
    </Styles.ChartContainer>
  )
}

export default ReturnsAndExchangesBarsChart
